import React from 'react';
import { Button, Heading, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { postPurchaseBi } from '../postPurchaseBi';
import styles from '../PostPurchaseStep.scss';

interface CoursePartnerBannerProps {
  actionUrl?: string;
  brandName: string;
}

export function CoursePartnerBanner({ actionUrl, brandName }: CoursePartnerBannerProps) {
  const { t } = useTranslation();

  function handleCourseClick(event: React.MouseEvent<HTMLAnchorElement>) {
    if (!actionUrl) {
      event.preventDefault();
      return;
    }

    postPurchaseBi.courseClick(brandName);
  }

  return (
    <section
      className={styles.postPurchaseCourseBanner}
      aria-label={t('post_purchase.course.aria_label', { brandName })}
    >
      <div className={styles.postPurchaseCourseCopy}>
        <Text size="small" weight="bold" light>
          {t('post_purchase.course.eyebrow')}
        </Text>
        <Heading as="h2" size="medium" light>
          {brandName}
        </Heading>
      </div>
      <Button
        as="a"
        href={actionUrl || '#'}
        disabled={!actionUrl}
        onClick={handleCourseClick}
        priority="secondary"
        size="medium"
        skin="light"
      >
        {t('post_purchase.course.cta')}
      </Button>
    </section>
  );
}
